import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-recommendation-card',
  templateUrl: './recommendation-card.component.html',
  styleUrls: ['./recommendation-card.component.scss']
})
export class RecommendationCardComponent implements OnInit {
  @Input() recommendation;
  constructor() {}

  ngOnInit() {}
}
